import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PageHeader } from "@/components/common/page-header";
import { UpdateResourceFieldsCard } from "./UpdateResourceFieldsCard";

/**
 * The one-off maintenance tools, one card each (SuperAdmin only). A new tool is one more card
 * component here.
 */
export function HelperPage() {
  return (
    <div className="space-y-5">
      <PageHeader
        title="Helper"
        subtitle="Maintenance tools an operator runs by hand. Nothing here runs until you start it."
        leading={
          <div className="hidden size-10 items-center justify-center rounded bg-primary/10 text-primary sm:flex">
            <Wrench className="size-5" />
          </div>
        }
      />

      <UpdateResourceFieldsCard />
      <JobGuideCard />
    </div>
  );
}

/**
 * The way to the background-jobs guide (`JobGuidePage`, SuperAdmin only): what each job does and
 * when it runs. A page rather than a popover, because the list is a page long. A job added,
 * removed or rescheduled is a row to change in `background-jobs.html` beside this file.
 */
function JobGuideCard() {
  return (
    <Card className="shadow-none">
      <CardHeader className="flex flex-row items-center justify-between gap-3 space-y-0 p-4">
        <div className="min-w-0 space-y-1">
          <CardTitle className="text-base">Job guide</CardTitle>
          <CardDescription>
            What each background job does and when it runs.
          </CardDescription>
        </div>
        <Button variant="outline" size="sm" asChild className="shrink-0">
          <Link to="/admin/helper/jobs">How this works</Link>
        </Button>
      </CardHeader>
    </Card>
  );
}
